var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5217 0.000862428C18.0218 0.0175184 17.5481 0.22852 17.2014 0.589029C13.5225 4.27586 10.713 7.3551 7.29856 10.8399L3.66153 7.76706C3.46854 7.60388 3.24525 7.48039 3.00445 7.40365C2.76365 7.32691 2.51008 7.29844 2.25826 7.31986C2.00643 7.34129 1.76131 7.41217 1.53694 7.52849C1.31257 7.64481 1.11335 7.80426 0.950703 7.9977C0.788055 8.19114 0.665174 8.41477 0.589099 8.65578C0.513025 8.89679 0.485252 9.15043 0.507373 9.40219C0.529494 9.65395 0.601073 9.89888 0.718009 10.1229C0.834945 10.347 0.994941 10.5458 1.18883 10.7079L6.18224 14.9331C6.54964 15.2426 7.01966 15.4031 7.49961 15.3831C7.97956 15.3631 8.43459 15.164 8.77497 14.8251C12.9118 10.6793 15.8566 7.36805 19.9141 3.3018C20.1928 3.03244 20.3835 2.6851 20.4611 2.30537C20.5387 1.92565 20.4996 1.53132 20.349 1.17422C20.1984 0.817114 19.9432 0.51393 19.6171 0.304511C19.291 0.0950919 18.9091 -0.0107476 18.5217 0.000862428Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.744b379e2471f1676d6399bd493a2bd7.svg";
export { ForwardRef as ReactComponent };